import {InternalLinkOption} from "../option"
import {LexicalEditor} from "lexical"
import {AlignType} from "../../toolbar/blocks/align/align"
import {lexicalAlignText} from "../../../actions/align-text"
import {PopoverMenuItemType} from "../../../../popover-menu/popover-menu/const"
import slashMenu_iconComponent from "./slah-menu-icon-component"

export default function editor_alignOptions(editor: LexicalEditor, isRTL: any) {

    const leftAlign = new InternalLinkOption('Left align', {
        id              : 'leftAlign',
        // icon            : 'editor-i5-left-align fs-16',
        iconComponent   : slashMenu_iconComponent('editor-i5-left-align'),
        keywords        : ['align', 'left'],
        action          : () => {
            lexicalAlignText(editor, AlignType.LEFT)
        }
    })

    const centerAlign = new InternalLinkOption('Center align', {
        id              : 'centerAlign',
        // icon            : 'editor-i5-center-align fs-16',
        iconComponent   : slashMenu_iconComponent('editor-i5-center-align'),
        keywords        : ['align', 'center'],
        action          : () => {
            lexicalAlignText(editor, AlignType.CENTER)
        }
    })

    const rightAlign = new InternalLinkOption('Right align', {
        id              : 'rightAlign',
        // icon            : 'editor-i5-right-align fs-16',
        iconComponent   : slashMenu_iconComponent('editor-i5-right-align'),
        keywords        : ['align', 'right'],
        action          : () => {
            lexicalAlignText(editor, AlignType.RIGHT)
        }
    })

    const justifyAlign = new InternalLinkOption('Justify align', {
        id              : 'justifyAlign',
        // icon            : 'editor-i5-justify-align fs-16',
        iconComponent   : slashMenu_iconComponent('editor-i5-justify-align'),
        keywords        : ['align', 'justify'],
        action          : () => {
            lexicalAlignText(editor, AlignType.JUSTIFY)
        }
    })

    const outdent = new InternalLinkOption('Outdent', {
        id              : 'outdent',
        // icon            : '{0} fs-16'.f(isRTL ? 'editor-i5-indent' : 'editor-i5-outdent'),
        iconComponent   : slashMenu_iconComponent('{0} fs-16'.f(isRTL ? 'editor-i5-indent' : 'editor-i5-outdent')),
        keywords        : ['outdent'],
        action          : () => {
            lexicalAlignText(editor, AlignType.OUTDENT)
        }
    })

    const indent = new InternalLinkOption('Indent', {
        id              : 'indent',
        // icon            : '{0} fs-16'.f(isRTL ? 'editor-i5-outdent' : 'editor-i5-indent'),
        iconComponent   : slashMenu_iconComponent( '{0} fs-16'.f(isRTL ? 'editor-i5-outdent' : 'editor-i5-indent')),
        keywords        : ['indent'],
        action          : () => {
            lexicalAlignText(editor, AlignType.INDENT)
        }
    })

    const options = [
        leftAlign,
        centerAlign,
        rightAlign,
        justifyAlign,
        outdent,
        indent
    ]

    let optionsBlockKeywords: string[] = []
    _.map(options, option=>optionsBlockKeywords = optionsBlockKeywords.concat(option.keywords))

    return [
        new InternalLinkOption('Align', {
            type        : PopoverMenuItemType.HEADER,
            keywords    : optionsBlockKeywords
        }),

        ...options,

        new InternalLinkOption('', {
            type        : PopoverMenuItemType.SEPARATOR,
            keywords    : optionsBlockKeywords
        }),
    ]
}